<template>
  <div class="procurementQuotationSettingsDetail">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <van-field
        v-model="form.UnitName_CN"
        :label="$t.procurementQuotationSettings.unitNameCN"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.UnitName_EN"
        :label="$t.procurementQuotationSettings.unitNameEN"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.UnitName_AR"
        :label="$t.procurementQuotationSettings.unitNameAR"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "procurementQuotationSettingsDetail",
  data() {
    return {
      isEdit: false,
      PUId: "",
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
    };
  },
  created() {
    const { IsEdit } = this.$route.query;
    this.isEdit = IsEdit;
    if (IsEdit) {
      var data = JSON.parse(localStorage.getItem("procurementQuotationSettingsDetail"));
      this.form = data;
    } else {
      this.form = {
        PUId: null,
        UnitName_CN: "",
        UnitName_EN: "",
        UnitName_AR: "",
      };
    }
  },
  methods: {
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      var request = null;
      if (this.isEdit) {
        request = this.$api.purchasingManagement.editProcurementQuotationUnit(param);
      } else {
        request = this.$api.purchasingManagement.addProcurementQuotationUnit(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.procurementQuotationSettingsDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
}
</style>
